<template>
    <div class="fullHeight">
        <MypageSideMenu :memberDropClose="false" />
        <Card
            iconclass="icon-icon-info mypage-title-icon"
            :page_title="page_title"
        >
            <div class="col-sm-12">
                <div class="row">
                    <div class="col">
                        <div class="quitMessage">会員を退会してよろしいですか？</div>
                    </div>
                </div>
                <div v-if="quit_checkbox.length > 0">
                    <div class="card-body">
                        <div class="messageBox">
                            <h5 class="font-weight-bold mb-4">アンケートにご協力ください</h5>
                            <p>退会理由をお聞かせください（複数回答可）</p>
                            <div class="row">
                                <div class="col-sm-6"
                                    v-for="checkbox in quit_checkbox"
                                    :key="checkbox.id"
                                >
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-model="selected_check"
                                            :value="checkbox.id"
                                        >
                                        <label class="form-check-label">
                                            {{ checkbox.reason }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="etc"
                                            v-model="etc_check"
                                        >
                                        <label class="form-check-label">
                                            その他（下の空欄へご入力ください）
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <textarea
                                            class="form-control"
                                            rows="3"
                                            ref="focusEtc"
                                            placeholder="その他の理由をご記入ください。"
                                            v-model="etc_reason"
                                            :disabled="!etc_check"
                                        ></textarea>
                                        <div
                                            class="text-danger"
                                            v-if="etc_reason.length > 3000"
                                        >その他の理由は3000文字以内で入力してください。</div>
                                    </div>
                                    <p v-if="etc_error" class="alert alert-danger">
                                        理由をご記入ください。
                                    </p>
                                    <p>※こちらにご入力頂いた内容については、ご返信致しておりません。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mypage-info-record justify-content-center">
                    <div class="col-lg-3 text-center py-2">
                        <button
                            type="button"
                            class="bluebackbutton footer-btn-size"
                            @click="clickQuitSubmit"
                            :disabled="btnDisable"
                        >
                            会員を退会する
                        </button>
                    </div>
                    <div class="col-lg-3 text-center py-2">
                        <button
                            type="button"
                            class="mypagebackbutton footer-btn-size"
                            @click="gotoMypageInfo"
                        >
                            戻る
                        </button>
                    </div>
                </div>
                <div v-if="errMessage !==''" class="text-danger text-center">
                    {{ errMessage }}
                </div>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import { GET_QUIT_CHECKBOX, ADD_WITHDRSWSLS } from '../../constants/member_quit.js';
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import { memberStatusMixin } from './memberStatusMixin';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    props: {
    },
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        Card
    },
    mixins: [memberStatusMixin],
    data () {
        return {
            page_title: '会員退会',
            quit_checkbox: [],
            selected_check: [],
            selected_checks: true,
            etc_reacon_checks: false,
            etc_check: false,
            etc_reason: '',
            etc_error: false,
            ev: '',
            errMessage: ''
        };
    },
    created () {
        this.initialize();
    },
    mounted () {

    },
    watch: {
        // /** ----------------------------------------------
        //  * 退会ボタン制御処理
        //  * ---------------------------------------------- */
        etc_check: function (now) {
            this.etc_reason = "";
            if (now) {
                this.$nextTick(function () {
                    this.$refs.focusEtc.focus();
                    this.$refs.focusEtc.blur();
                });
            }
        }
    },
    computed: {
        btnDisable () {
            if (this.selected_check.length !== 0) {
                if (this.etc_check) {
                    return this.etcLengthCheck(this.etc_reason);
                } else {
                    return false;
                }
            } else if (this.etc_check) {
                return this.etcLengthCheck(this.etc_reason);
            } else {
                return true;
            }
        }
    },
    methods: {
        etcLengthCheck (reason) {
            if (reason.length === 0) {
                return true;
            } else if (reason.length > 3000) {
                return true;
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.$store.commit("loading/setIsLoading", true);
            this.GetLoginUserMemberStatus();
            // チェックボックスの値を取得
            await this.$apollo.mutate({
                mutation: GET_QUIT_CHECKBOX,
                variables: {}
            }).then(res => {
                this.quit_checkbox = res.data.withdrawalReasonCheckbox;
            });
            this.$store.commit("loading/setIsLoading", false);
        },
        /** ----------------------------------------------
         * マイページトップに戻るボタン処理
         * ---------------------------------------------- */
        BackMyPage: function (){
            // マイページトップ画面へ遷移
            this.$router.push({ path: '/mypage' });
        },
        /** ----------------------------------------------
         * 退会ボタン押下時の処理
         * ---------------------------------------------- */
        clickQuitSubmit: async function () {
            if (this.etc_check) {
                if (this.etc_reason.length > 3000) {
                    this.etc_error = false;
                    return;
                } else if (this.etc_reason.length === 0) {
                    this.etc_error = true;
                    return;
                }else {
                    this.etc_error = false;
                }
            }
            this.$store.commit("loading/setIsLoading", true);
            this.GetLoginUserMemberStatus();
            await this.$apollo.mutate({
                mutation: ADD_WITHDRSWSLS,
                variables: {
                    reason_other: this.etc_reason,
                    checkbox_reason_id: this.selected_check
                }
            }).then(res => {
                if (res.data.addWithdrawals.result === 9) {
                    this.errMessage = 'キャンセルされていない予約が存在します。恐れ入りますがキャンセル後の退会をお願いします。';
                    this.$store.commit("loading/setIsLoading", false);
                } else {
                    this.$router.push({ path: '/mypage-quit-complete' });
                }
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        /** ----------------------------------------------
         * 戻るボタンの処理 会員情報参照画面へ
         * ---------------------------------------------- */
        gotoMypageInfo: function () {
            this.$router.push({ path: '/mypage-info' });
        }
    }
}

</script>

<style scoped>
</style>
